<template>
    <a-dropdown :trigger="['click']" style="float:right;margin:15px 24px 0 0;">
        <a style="color:#fff" class="ant-dropdown-link" @click="e => e.preventDefault()">
            <span style="margin-right:16px;">个人中心</span> 
            <a-icon type="down" />
        </a>
        <a-menu slot="overlay">
            <a-menu-item key="0" @click="handleLogout">
                <a-icon type="poweroff" />
                <span>退出登录</span>
            </a-menu-item>
        </a-menu>
    </a-dropdown>
</template>

<script>
export default {
  name: 'Logout',
  props: {
    msg: String
  },
   data() {
    return {

    }
  },
  methods: {
    handleLogout () {
        this.$confirm({
            title: '提示',
            content: '真的要注销登录吗 ?',
            okText: "确认",
            cancelText: "取消",
            onOk: () => {
                this.sessionData('clean','token');
                this.sessionData('clean','role');
                this.$router.push("/Login")
            },
            onCancel () {
            }
        })
    },
  },
  mounted: function() {

  }
}
</script>

<style scoped lang="less">

</style>
